module.exports = __webpack_public_path__ + "img/bg-login.c2e963c5.jpg";